// extracted by mini-css-extract-plugin
export var option = "_8f-0";
export var optionCard = "_8f-f";
export var optionContent = "_8f-g";
export var optionIcon = "_8f-i";
export var optionIconBox = "_8f-h";
export var optionLabel = "_8f-j";
export var optionPill = "_8f-m";
export var optionPillBadge = "_8f-p";
export var optionPillIcon = "_8f-n";
export var optionPillLabel = "_8f-o";
export var optionRadio = "_8f-k";
export var optionRadioInner = "_8f-l";
export var optionReveal = "_8f-2";
export var optionRevealDelay0 = "_8f-3";
export var optionRevealDelay1 = "_8f-4";
export var optionRevealDelay10 = "_8f-d";
export var optionRevealDelay11 = "_8f-e";
export var optionRevealDelay2 = "_8f-5";
export var optionRevealDelay3 = "_8f-6";
export var optionRevealDelay4 = "_8f-7";
export var optionRevealDelay5 = "_8f-8";
export var optionRevealDelay6 = "_8f-9";
export var optionRevealDelay7 = "_8f-a";
export var optionRevealDelay8 = "_8f-b";
export var optionRevealDelay9 = "_8f-c";
export var optionSelected = "_8f-1";